import React from "react";
import "../styles/footer.scss";
import setLogo from "../assets/set_logo.svg";
import matrixLogo from "../assets/matrix_logo.svg";

export default function Footer() {
  return (
    <div className="footerContainer">
      <div className="footerFirstHalf">
        <div className="footerContact">
          <div>
            <i className="fas fa-envelope fa-2x" />
            <p>info@societaeconomiaterritorio.it</p>
          </div>
          <div>
            <i className="fab fa-facebook-square fa-2x" />
            <p>loremipsum</p>
          </div>
        </div>
        <div className="footerLogos">
          <img alt="setLogo" src={setLogo} />
          <img alt="matrixLogo" src={matrixLogo} />
        </div>
      </div>
      <div className="footerSecondHalf">
        <p>GDPR Policy</p>
        <p>Powered by Matrix Software House</p>
        <p>© 2021 SET, Tutti i diritti riservati, Privacy Policy</p>
      </div>
    </div>
  );
}
